import changePasswordService from '@/services/changePassword/changePassword.service';
import types from '@/store/modules/common/mutation-types-core'

const state = {}
const getters = {}
const mutations = {}
const actions = {
    async changePassword({ commit }, payload) {
        try {
            let response = await changePasswordService.changePassword(payload)
            return response;
        } catch (error) {
            throw new Error(error.message)
        }
    },
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}